import React, { useState, useEffect } from "react";
import firebase from "firebase/app";
import { dbApp } from "../../../firebase/config";
import { Carousel, Modal, Button } from "react-bootstrap";
import Cargando from "../../Cargando";

const SlidePrincipal = () => {
  const [sliderImages, setsliderImages] = useState({});
  const [progress, setProgress] = useState(5);
  const [mostrarSlider, setMostrarSlider] = useState(false);
  const [cargandoSlider, setCargandoSlider] = useState(false);

  const [show, setShow] = useState(false);
  const [interval, setInterval] = useState(3000);
  const [urlImage, setUrlImage] = useState(null);

  useEffect(() => {
    getSlider();
  }, []);

  const getSlider = () => {
    console.log("Cargando...");
    setMostrarSlider(false);
    setCargandoSlider(true);
    dbApp
      .collection("slider")
      .where("negocio", "==", "1")
      .get()
      .then(response => {
        setCargandoSlider(false);
        response.forEach(doc => {
          const slider = doc.data();
          slider.id = doc.id;
          setsliderImages(slider);
          setMostrarSlider(true);
        });
      });
  };

  const handleUpload = event => {
    const file = event.target.files[0];
    const storeRef = firebase.storage().ref(`slider/${file.name}`);
    const task = storeRef.put(file);

    task.on(
      "state_changed",
      snapshot => {
        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
        console.log("Upload is " + progress + "% done");
      },
      error => {
        console.log("Ocurrio un error al subir las imagenes.");
      },
      () => {
        task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
          console.log("File available at", downloadURL);
          let images = [];
          images.push(downloadURL);

          const dataForm = {
            negocio: "1",
            images
          };

          if (Object.keys(sliderImages).length > 0) {
            let imagesActuales = [];
            const copiaSlider = sliderImages;
            imagesActuales = copiaSlider.images;
            const imagenesFinal = imagesActuales.concat(images);

            dbApp
              .collection("slider")
              .doc(sliderImages.id)
              .update({
                images: imagenesFinal
              })
              .then(r => {
                console.log("Actualizado");
                getSlider();
              });
          } else {
            dbApp
              .collection("slider")
              .add(dataForm)
              .then(response => {
                console.log("Agregado");
                getSlider();
              })
              .catch(e => {
                console.log("Error: ", e);
              });
          }
        });
      }
    );
  };

  let mostrar;
  if (cargandoSlider) {
    mostrar = <Cargando />;
  } else if (!mostrarSlider) {
    mostrar = (
      <Carousel.Item>
        <img src="https://via.placeholder.com/1200X300" alt="Hola" />
      </Carousel.Item>
    );
  }
  const handleClose = () => {
    setShow(false);
    setInterval(3000);
  };

  const handleShow = url => {
    setUrlImage(url);
    setInterval(30000);
    setShow(true);
  };

  const handleConfirm = () => {
    var desertRef = firebase.storage().refFromURL(urlImage);
    console.log(desertRef);

    // Delete the file
    desertRef
      .delete()
      .then(function() {
        let imagesActuales = sliderImages.images;
        console.log("imagesActuales");
        let imagenesNew = imagesActuales.filter(url => url !== urlImage);
        console.log("imagenesNew");
        dbApp
          .collection("slider")
          .doc(sliderImages.id)
          .update({
            images: imagenesNew
          })
          .then(r => {
            console.log("Actualizado");
            setInterval(3000);
            setShow(false);
            getSlider();
          });
      })
      .catch(function(error) {
        console.log("error");
      });
  };

  return (
    <>
      <Carousel
        className="border"
        interval={interval}
        style={{ cursor: "pointer" }}
      >
        {mostrarSlider
          ? sliderImages.images.map((slideUrl, index) => (
              <Carousel.Item
                key={index}
                style={{ height: "300px" }}
                onClick={() => handleShow(slideUrl)}
              >
                <img
                  src={slideUrl}
                  alt="Slider Inicio"
                  className="w-100 h-100"
                />
              </Carousel.Item>
            ))
          : mostrar}
      </Carousel>

      {parseInt(progress) > 5 && (
        <div className="progress mt-1">
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: progress + "%" }}
            aria-valuenow={progress}
            aria-valuemin="1"
            aria-valuemax="100"
          >
            {parseInt(progress) > 0 ? progress + "%" : null}
          </div>
        </div>
      )}

      <div className="d-flex justify-content-center mt-2">
        <div className="form-group">
          <span className="btn btn-primary btn-file">
            <i className="fa fa-upload" aria-hidden="true"></i>
            <input
              type="file"
              id="images"
              name="images"
              multiple
              accept="image/*"
              onChange={handleUpload}
            />
          </span>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar Imagen!</Modal.Title>
        </Modal.Header>
        <Modal.Body>¿Desea eliminar la imagen?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            <i className="fa fa-ban" aria-hidden="true"></i> Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            <i className="fa fa-trash" aria-hidden="true"></i> Eliminar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SlidePrincipal;
